import { render, staticRenderFns } from "./OtherMessage.vue?vue&type=template&id=7080ca10&scoped=true&"
import script from "./OtherMessage.vue?vue&type=script&lang=js&"
export * from "./OtherMessage.vue?vue&type=script&lang=js&"
import style0 from "./OtherMessage.vue?vue&type=style&index=0&id=7080ca10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7080ca10",
  null
  
)

export default component.exports